import { ROLLOUTS } from '@fiverr-private/listing_experiments';
import { useAppContext } from '../../components/context/listingsContext';

export const usePersonalAssistantRolloutEnabled = (): boolean => {
    const { rollouts } = useAppContext();

    return rollouts[ROLLOUTS.STARLINGS_AI_ASSISTANT_FILTER_TOGGLE];
};
